/**
 * Countries that use miles as their primary distance unit
 * GB - United Kingdom
 * US - United States
 * LR - Liberia
 * MM - Myanmar (Burma)
 */
const COUNTRIES_USING_MILES = ['GB', 'US', 'LR', 'MM'];

/**
 * Conversion factor from miles to kilometers
 */
const MILES_TO_KM = 1.60934;

/**
 * Converts miles to the appropriate distance unit based on country
 * @param {number} miles - Distance in miles
 * @param {string} country - ISO 3166-1 alpha-2 country code
 * @returns {number} Distance in miles or kilometers depending on country
 */
export function convertMilesToCountryUnit(miles, country) {
    return COUNTRIES_USING_MILES.includes(country)
        ? miles
        : miles * MILES_TO_KM;
}

/**
 * Checks if a country uses miles as its primary distance unit
 * @param {string} country - ISO 3166-1 alpha-2 country code
 * @returns {boolean} True if country uses miles, false otherwise
 */
export function countryUsesMiles(country) {
    return COUNTRIES_USING_MILES.includes(country);
}
